import './codeBlockSingleLine.scss';

import React, { FunctionComponent } from 'react';

import { useCopyToClipboard } from '../../hooks/useCopyToClipboard';
import { useTranslation } from 'react-i18next';

type Props = {
  textContents: string;
  buttonId?: string;
  codeId?: string;
};

const CodeBlockSingleLine: FunctionComponent<Props> = ({
  textContents,
  buttonId = 'codeBlockSingleLine-button',
  codeId = 'codeBlockSingleLine-code',
}) => {
  const { t } = useTranslation();
  const copyToClipboard = useCopyToClipboard();

  return (
    <div className="codeBlockSingleLine">
      <input
        type="text"
        className="codeBlockSingleLine__input"
        readOnly
        value={textContents}
      />
      <div className="jg-hidden" id={codeId} data-qa={codeId}>
        {textContents}
      </div>
      <button
        type="button"
        id={buttonId}
        data-qa={buttonId}
        className="jg-btn jg-btn--secondary setup__buttons__copy-link gc-button-width codeBlockSingleLine__button"
        onClick={() => {
          copyToClipboard(buttonId, codeId);
        }}
      >
        {t('common.copy')}
      </button>
    </div>
  );
};

export default CodeBlockSingleLine;
